module.exports = __webpack_public_path__ + "static/media/leftHand.83a116ff.svg";